import { useEffect, useState } from "react";
import {
  getProfile,
  updateProfile,
  updateAccount,
  updatePhoto,
} from "../services/authService";
import { AccountPayload, ProfilePayload } from "../types";
import AccountInfo from "./components/AccountInfo";
import PersonalInfo from "./components/PersonalInfo";

export default function Profile() {
  const [data, setData] = useState<any>(null);
  const [formAccount, setFormAccount] = useState<AccountPayload>({
    name: "",
    email: "",
    mobile_no: "",
    change_password: false,
    current_password: undefined,
    password: undefined,
    password_confirmation: undefined,
  });
  const [formProfile, setFormProfile] = useState<ProfilePayload>({
    user_id: 0,
    full_name: "",
    gender: "",
    dob: "",
    contact_address: "",
    emergency_contact_person: "",
    emergency_contact_number: "",
    emergency_contact_address: "",
  });
  const [formPhoto, setFormPhoto] = useState<any>(null);

  useEffect(() => {
    getProfile()
      .then((res) => {
        setData(res?.data);
        setFormAccount(res?.data?.user);
        setFormProfile(res?.data);
      })
      .catch(() => {
        localStorage.removeItem("token");
        window.location.href = "/";
      });
  }, []);

  if (!data) return <div className="container py-5">Loading...</div>;

  const handleSaveAccount = async (formAccount: any) => {
    await updateAccount(formAccount);
    setData({ ...data, user: formAccount });
  };

  const handleSaveProfile = async (formProfile: any) => {
    await updateProfile(formProfile);
    setData({ ...data, ...formProfile });
  };

  const handleSavePhoto = async () => {
    if (!formPhoto) return;

    const formData = new FormData();
    formData.append("user_id", data.user.id);
    formData.append("photo", formPhoto);

    try {
      const newUserData = await updatePhoto(formData);
      setData({
        ...data,
        photo_path: newUserData?.data?.profile?.photo_path,
      });
      setFormPhoto(null);
    } catch (error) {
      console.error("Photo update failed:", error);
    }
  };

  return (
    <div className="container-fluid p-0">
      {/* Page Header */}
      <div className="mb-3">
        <h1 className="h3 d-inline align-middle">Profile</h1>
      </div>

      <div className="row">
        {/* LEFT SIDEBAR */}
        <div className="col-md-4 col-xl-3">
          <div className="card mb-3">
            <div className="card-header">
              <h5 className="card-title mb-0">Profile Details</h5>
            </div>
            <div className="card-body text-center">
              {/* Profile Photo */}
              <img
                src={
                  formPhoto
                    ? URL.createObjectURL(formPhoto)
                    : !data.photo_path
                    ? "user-photo-bg.jpg"
                    : data.photo_path
                }
                alt={formAccount.name}
                className="img-fluid rounded-circle mb-2"
                width="128"
                height="128"
              />

              <h5 className="card-title mb-0">{formAccount.name}</h5>
              <div className="text-muted mb-2">{formProfile.contact_address}</div>

              {/* Change Photo */}
              <input
                type="file"
                id="fileInput"
                accept="image/*"
                style={{ display: "none" }}
                onChange={(e) => {
                  const file = e.target.files?.[0];
                  if (file) setFormPhoto(file);
                }}
              />
              <div className="mt-2">
                <button
                  className="btn btn-sm btn-outline-primary me-2"
                  onClick={() =>
                    document.getElementById("fileInput")?.click()
                  }
                >
                  Change Photo
                </button>
                {formPhoto && (
                  <button
                    className="btn btn-sm btn-success"
                    onClick={handleSavePhoto}
                  >
                    Save
                  </button>
                )}
              </div>
            </div>

            <hr className="my-0" />

            {/* Account Info Form */}
            <div className="card-body">
              <h5 className="h6 card-title">Account</h5>
              <AccountInfo
                data={data}
                formAccount={formAccount}
                setFormAccount={setFormAccount}
                onSave={handleSaveAccount}
              />
            </div>

            <hr className="my-0" />

            {/* About Section */}
            <div className="card-body">
              <h5 className="h6 card-title">About</h5>
              <ul className="list-unstyled mb-0">
                <li className="mb-1">
                  <i className="bi bi-house-door me-1"></i>
                  Lives in <span>{formProfile.contact_address}</span>
                </li>
                <li className="mb-1">
                  <i className="bi bi-briefcase me-1"></i>
                  Works at <span>GitHub</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* RIGHT CONTENT */}
        <div className="col-md-8 col-xl-9">
          <div className="card">
            <div className="card-header">
              <h5 className="card-title mb-0">Personal Info</h5>
            </div>
            <div className="card-body">
              <PersonalInfo
                data={data}
                formProfile={formProfile}
                setFormProfile={setFormProfile}
                onSave={handleSaveProfile}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
